import type {Dayjs} from 'dayjs'

export const mapDays = (start: Dayjs, end: Dayjs): Dayjs[] => {
  const dayCount = end.diff(start, 'days', true)
  if (dayCount <= 0) return []

  const days: Dayjs[] = []
  let current = start.startOf('day')
  while (current.isBefore(end)) {
    days.push(current.startOf('day'))
    current = current.add(1, 'day')
  }
  return days
}
